import { useRef, useState } from 'react';
import { uploadIndirectPaymentImport } from '../../services/kollectaApi';
import styles from './style.module.css';
import Icon from './../../assets/images/iconnewDark.svg';
import Modal from '../Modal';
import ReactLoading from 'react-loading';
import success from '../../assets/images/dataSuccess.svg';
import error from '../../assets/images/error.svg';
import warning from '../../assets/images/warningOrange.svg';
import * as xlsx from 'xlsx';

const IndirectPaymentUpload = () => {
  const filesElement = useRef(null);
  const [files, setFiles] = useState([]);
  const [popUpFeedBack, setPopUpFeedBack] = useState({
    loading: false,
    confirm: false,
    success: false,
    typeError: false,
    message: '',
    totalDocuments: 0,
    dataForm: null,
    result: null,
  });

  const validateFile = async () => {
    setPopUpFeedBack((prev) => ({ ...prev, loading: true, typeError: false, message: '' }));

    try {
      const selectedFiles = filesElement.current.files;
      if (!selectedFiles?.length) {
        setPopUpFeedBack((prev) => ({
          ...prev,
          loading: false,
          typeError: true,
          message: 'Selecione um arquivo Excel.',
        }));
        return;
      }

      const file = selectedFiles[0];
      const dataForm = new FormData();
      dataForm.append('file', file);
      setFiles([file]);

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const workbook = xlsx.read(e.target.result, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const sheetData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });

          if (!sheetData.length) {
            setPopUpFeedBack((prev) => ({
              ...prev,
              loading: false,
              typeError: true,
              message: 'Arquivo Excel está vazio.',
            }));
            return;
          }

          const headers = (sheetData[0] || []).map((header) => String(header || '').trim());
          const cpfIndex = headers.indexOf('cpf_ou_cnpj');

          if (cpfIndex === -1) {
            setPopUpFeedBack((prev) => ({
              ...prev,
              loading: false,
              typeError: true,
              message: 'A planilha precisa ter a coluna cpf_ou_cnpj.',
            }));
            return;
          }

          const rows = sheetData
            .slice(1)
            .filter((row) => row.some((cell) => cell !== undefined && cell !== ''));

          const documents = rows
            .map((row) => String(row[cpfIndex] ?? '').replace(/[^\d]/g, ''))
            .filter(Boolean);

          if (!documents.length) {
            setPopUpFeedBack((prev) => ({
              ...prev,
              loading: false,
              typeError: true,
              message: 'Nenhum CPF/CNPJ válido encontrado na planilha.',
            }));
            return;
          }

          setPopUpFeedBack((prev) => ({
            ...prev,
            loading: false,
            confirm: true,
            totalDocuments: new Set(documents).size,
            dataForm,
          }));
        } catch (validationError) {
          setPopUpFeedBack((prev) => ({
            ...prev,
            loading: false,
            typeError: true,
            message: validationError.message || 'Não foi possível validar o arquivo.',
          }));
        }
      };

      reader.readAsBinaryString(file);
    } catch (err) {
      setPopUpFeedBack((prev) => ({
        ...prev,
        loading: false,
        typeError: true,
        message: err.message || 'Não foi possível validar o arquivo.',
      }));
    }
  };

  const sendFile = async (dataForm) => {
    try {
      setPopUpFeedBack((prev) => ({ ...prev, loading: true, confirm: false }));
      const response = await uploadIndirectPaymentImport(dataForm);
      setPopUpFeedBack((prev) => ({
        ...prev,
        loading: false,
        success: true,
        result: response.data,
      }));
    } catch (err) {
      setPopUpFeedBack((prev) => ({
        ...prev,
        loading: false,
        typeError: true,
        message: err?.data?.message || err?.response?.data?.message || 'Não foi possível atualizar o status das dívidas.',
      }));
    }
  };

  return (
    <div className={styles.uploadFileContainer}>
      <div className={styles.contentInputFile}>
        <div className={styles.inputFileUploadContainer}>
          <h1>Upload da planilha de atualização</h1>
          <input
            className={styles.inputFile}
            id="indirect-payment-file"
            type="file"
            accept=".csv, .xlsx, .xls"
            onChange={validateFile}
            ref={filesElement}
          />
          <label tabIndex="0" htmlFor="indirect-payment-file" className={styles.inputFileTrigger}>
            <span className={styles.triggerIcon}>
              <img className={styles.inputIcon} src={Icon} alt="upload files" />
            </span>
            Arraste a planilha com a coluna cpf_ou_cnpj
            <h5>ou</h5>
            <label tabIndex="0" htmlFor="indirect-payment-file" className={styles.btnUpload}>
              Buscar arquivo
            </label>
          </label>
        </div>
      </div>

      <div className={styles.list}>
        <h1>Arquivos recebidos</h1>
        <div className={styles.listContainer}>
          <div className={styles.fileItens}>
            {files.map((file, index) => (
              <div className={styles.fileItem} key={`${file.name}-${index}`}>
                <h3 className={styles.itemNameFile}>{file.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      {popUpFeedBack.loading && (
        <Modal onClose={() => setPopUpFeedBack((prev) => ({ ...prev, loading: false }))}>
          <div className={styles.modalContainer}>
            <p>Atualizando o status das dívidas para Pagamento indireto...</p>
            <ReactLoading type="spin" color="#293053" height={50} width={50} />
          </div>
        </Modal>
      )}

      {popUpFeedBack.confirm && (
        <Modal onClose={() => setPopUpFeedBack((prev) => ({ ...prev, confirm: false }))}>
          <div className={styles.modalContainer}>
            <img src={warning} alt="warning" />
            <p>
              Você está prestes a <b>atualizar o status</b> das dívidas de{' '}
              <b>{popUpFeedBack.totalDocuments} CPF/CNPJ</b> para{' '}
              <b>Pagamento indireto</b>.
            </p>
            <p className={styles.confirmHint}>
              Isso não cadastra novas dívidas — apenas altera o status das existentes.
            </p>
            <button
              className={styles.btnSubmit}
              onClick={() => sendFile(popUpFeedBack.dataForm)}
            >
              Confirmar atualização de status
            </button>
          </div>
        </Modal>
      )}

      {popUpFeedBack.success && (
        <Modal onClose={() => setPopUpFeedBack((prev) => ({ ...prev, success: false }))}>
          <div className={styles.modalContainer}>
            <img src={success} alt="success" />
            <p>
              Status atualizado para <b>Pagamento indireto</b> com sucesso.
            </p>
            <p>
              Documentos na planilha: <b>{popUpFeedBack.result?.totalDocuments ?? 0}</b>
              <br />
              Dívidas atualizadas: <b>{popUpFeedBack.result?.updated ?? 0}</b>
            </p>
          </div>
        </Modal>
      )}

      {popUpFeedBack.typeError && (
        <Modal onClose={() => setPopUpFeedBack((prev) => ({ ...prev, typeError: false }))}>
          <div className={styles.modalContainer}>
            <img src={error} alt="error" />
            <p>Não foi possível processar a atualização de status.</p>
            <p>{popUpFeedBack.message}</p>
            <button
              className={styles.btnSubmit}
              onClick={() => setPopUpFeedBack((prev) => ({ ...prev, typeError: false }))}
            >
              Fechar
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default IndirectPaymentUpload;
